export const NSFW_CLASSES: {[classId: number]: 'Drawing' | 'Hentai' | 'Neutral' | 'Porn' | 'Sexy'} = {
    0: 'Drawing',
    1: 'Hentai',
    2: 'Neutral',
    3: 'Porn',
    4: 'Sexy'
}
